import bridgeFunc from '@/plugins/bridgeFunc'
import axios from 'axios'
import dayjs from 'dayjs'
import qs from 'qs'
export default {
  // 空值判断
  isEmpty(obj) {
    if (typeof obj === 'undefined' || obj === null || obj === '' || obj === 'undefined' || obj === 'null' || JSON.stringify(obj) === '[]' || JSON.stringify(obj) === '{}') {
      return true
    } else {
      return false
    }
  },
  // 判断是否是对象json
  isJSON(str) {
    if (typeof str === 'string') {
      try {
        var obj = JSON.parse(str)
        if (typeof obj === 'object' && obj) {
          return true
        } else {
          return false
        }
      } catch (e) {
        console.log('error：' + str + '!!!' + e)
        return false
      }
    }
    console.log('It is not a string!')
  },
  /**
   * 版本号对比
   * @param {*} currVersion 当前版本号 支持写法v1.1.2 或者1.1.2
   * @param {*} targetVerison 要对比的版本号 支持写法v1.1.2 或者1.1.2
   * @returns
   */
  compareVersionEle(targetVerison, currVersion = '') {
    return new Promise((resolve, reject) => {
      if (!targetVerison) {
        resolve(false)
      }
      let compareTimer = setTimeout(() => {
        resolve(false)
      }, 500)
      if (!currVersion) {
        bridgeFunc.getAppInfo(res => {
          clearTimeout(compareTimer)
          currVersion = res.appVersion
          console.log(res)
          if (!currVersion) {
            resolve(false)
          }
          let currVersionVal = currVersion.toString()
          let targetVerisonVal = targetVerison.toString()
          if (currVersionVal && currVersion.startsWith('v')) {
            currVersionVal = currVersionVal.slice(1)
          }
          if (targetVerisonVal && targetVerisonVal.startsWith('v')) {
            targetVerisonVal = targetVerisonVal.slice(1)
          }
          const v1 = currVersionVal.split('.')
          const v2 = targetVerisonVal.split('.')
          const len = Math.max(v1.length, v2.length)
          // 调整两个版本号位数相同
          while (v1.length < len) {
            v1.push('0')
          }
          while (v2.length < len) {
            v2.push('0')
          }
          // 循环判断每位数的大小
          for (let i = 0; i < len; i++) {
            const num1 = parseInt(v1[i])
            const num2 = parseInt(v2[i])
            if (num1 > num2) {
              resolve(true)
            } else if (num1 < num2) {
              resolve(false)
            }
          }
          resolve(true)
        })
      }
    })
  },
  // 点击埋点
  plusCollect({user_id, event_code, event_name, page_id, event_type, extra_event_map}) {
    try {
      let timeNow = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS')
      let postUrl = ''
      if (location.host === 'yuhunh5.mloveli.com' || location.host === '106.75.13.64:8890') { // 测试或者3000
        postUrl = 'http://fath5-dongpingcollect.openxiaoniu.com'
      }  else if (location.host === 'www.yiguowl.top') { // 生产
        postUrl = 'http://h5dongpingcollect.openxiaoniu.com'
      } else {
        return
      }
      bridgeFunc.getAppInfo(res => {
        if (!res.uuid) return
        let targetEventCode = event_code.indexOf("h5_") == 0 ? event_code : "h5_" + event_code
        let params = {
          common: {
            upload_time: timeNow,
            os_system: "5",
            app_id: '304705',
            app_version: res.appVersion,
            product_name: "3047",
            message_id: "1",
            phone_model: res.phoneModel,
            uuid: res.uuid,
            os_version: res.osVersion,
            extra_common_map: {'appName': 'yuhunh5'},
          },
          events: [{
            event_type: event_type || 'click',
            event_code: targetEventCode,
            event_name: event_name,
            ts: timeNow,
            page_id: page_id,
            // browse_time: "页面浏览时长",
            user_id: user_id,
            extra_event_map: extra_event_map || {'appName': 'yuhunh5'}
          }]
        }
        console.warn('埋点数据' + JSON.stringify(params))
        axios.post(postUrl, JSON.stringify(params)).then(res => {})
      })
    } catch(err) {
      console.error(err)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/commonFunc.js